import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Inject,
} from "@angular/core";
import { Coletor } from "../coletor/coletor";
import { Doador } from "../doador/doador";
import { TecidoList } from "../tecidos-captados/tecido";
import html2pdf from "html2pdf.js";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PdfFichaPageComponent } from "../pdf-ficha-page/pdf-ficha-page.component";

export interface DialogData {
  doador: Doador;
  coletor: Coletor;
  listaTecidosCapatados: TecidoList;
  fichaValida: boolean;
}

@Component({
  selector: "app-pdf-ficha-create",
  templateUrl: "./pdf-ficha-create.component.html",
  styleUrls: ["./pdf-ficha-create.component.css"],
})
export class PdfFichaCreateComponent implements OnInit {
  @ViewChild("fichaPDF", { static: true, read: ViewContainerRef })
  fichaPDF: ViewContainerRef;

  constructor(
    private readonly resolver: ComponentFactoryResolver,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.createPDF();
  }

  createPDF(): void {
    this.fichaPDF.clear();
    const factory = this.resolver.resolveComponentFactory(
      PdfFichaPageComponent
    );
    const componentRef = this.fichaPDF.createComponent(factory);
    componentRef.instance.doador = this.data.doador;
    componentRef.instance.coletor = this.data.coletor;
    componentRef.instance.listaTecidosCapatados =
      this.data.listaTecidosCapatados;
    componentRef.instance.fichaValida = this.data.fichaValida;

    componentRef.instance.emitter.subscribe(() => {
      const config = {
        html2canvas: {
          scale: 1,
          scrollX: 0,
          scrollY: 10,
        },
      };

      this.print(componentRef.location.nativeElement, config);
      componentRef.destroy();
    });
  }

  print(content: any, config: any): void {
    var opt = {
      margin: [30, 5],
      pagebreak: { mode: "avoid-all" },
      html2canvas: {
        letterRendering: true,
      },
    };

    html2pdf()
      .from(content)
      .toContainer()
      .toCanvas()
      .toImg()
      .set(opt)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        var totalPages = pdf.internal.getNumberOfPages();
        //print current pdf width & height to console
        console.log("getHeight:" + pdf.internal.pageSize.getHeight());
        console.log("getWidth:" + pdf.internal.pageSize.getWidth());
        for (var i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(150);
          //divided by 2 to go center
          pdf.addImage(
            "data:image/png;base64,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",
            "png",
            15,
            5
          );
        }
        window.open(pdf.output("bloburl"), "_blank");
      });
  }
}
